import { Link } from "react-router-dom";
import { useSiteSetting } from "@/hooks/useCms";
import { Megaphone } from "lucide-react";

type Banner = { enabled?: boolean; text?: string; link?: string };

const TopBanner = () => {
  const { data } = useSiteSetting<Banner>("top_banner");
  if (!data?.enabled || !data?.text) return null;

  const content = (
    <div className="flex items-center justify-center gap-2 text-xs sm:text-sm font-medium text-foreground px-4 py-2">
      <Megaphone className="w-3.5 h-3.5 text-primary flex-shrink-0" />
      <span className="truncate">{data.text}</span>
    </div>
  );

  return (
    <div
      className="w-full border-b"
      style={{
        background: "linear-gradient(90deg, hsl(174 90% 50% / 0.12), hsl(280 80% 55% / 0.12), hsl(320 85% 55% / 0.12))",
        borderColor: "hsl(174 90% 50% / 0.2)",
      }}
    >
      {data.link ? (
        data.link.startsWith("http") ? (
          <a href={data.link} target="_blank" rel="noopener noreferrer" className="block hover:opacity-90">{content}</a>
        ) : (
          <Link to={data.link} className="block hover:opacity-90">{content}</Link>
        )
      ) : content}
    </div>
  );
};

export default TopBanner;
